import { EntityState } from 'redux-ngrx-entity';

export interface Language {
  drawer: Object;
  current: Options;
  options: Options[];
  newOptions: Options[];
}

export interface LanguageState extends EntityState<Language> {
  drawer: {
    isOpen: boolean;
    context: string;
  };
  current: Options;
  options: Options[];
  newOptions: Options[];
}

export type Drawer = {
  isOpen: boolean;
};

export enum newLanguagesOptions {
  EN = 'en',
  US = 'en-US',
  PT = 'pt-BR',
  PT_PT = 'pt-PT',
  ES = 'es',
  AR = 'es-AR',
  DE = 'de-DE',
  FR = 'fr-FR',
  PL = 'pl-PL',
  HU = 'hu-HU',
  IT = 'it-IT',
  TH = 'th-TH',
  VI = 'vi-VN',
  RU = 'ru-RU',
  ID = 'id-ID'
}

export enum Options {
  EN = 'en',
  US = 'en-US',
  PT = 'pt-BR',
  PT_PT = 'pt-PT',
  ES = 'es',
  AR = 'es-AR',
  DE = 'de-DE',
  FR = 'fr-FR',
  PL = 'pl-PL',
  HU = 'hu-HU'
}

export interface LanguageStage {
  language: string;
  stage: TranslationStages;
}

export enum TranslationStages {
  COMPLETE = 'COMPLETE',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE'
}
